import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.622 6.243a.6.6 0 0 0-.17-.416l-4.05-3.952a.5.5 0 0 0-.38-.175.496.496 0 0 0-.494.504c0 .14.045.276.134.38L8 3.923l2.325 2.254.117-.298-1.834-.116H.559c-.33 0-.559.238-.559.48 0 .24.23.479.56.479h8.048l1.834-.116-.117-.292L8 8.563l-1.338 1.34a.56.56 0 0 0-.134.38c0 .278.216.503.495.503a.53.53 0 0 0 .37-.161l4.058-3.966a.6.6 0 0 0 .17-.416"
    }, null, -1)
  ])))
}
export default { render: render }